import React from 'react'
import { Breadcrumb } from '@chakra-ui/react'
import { FaChevronRight } from 'react-icons/fa'
import { Link } from 'react-router'
import { Icon } from '.'

export default function SimpleBreadcrumbs ({ items }) {
  return (
    <Breadcrumb.Root gap='8px'>
      <Breadcrumb.List>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <Breadcrumb.Item>
              {item.to ? <Breadcrumb.Link as={Link} to={item.to} color='fg.default'>{item.label}</Breadcrumb.Link> : <span>{item.label}</span>}
            </Breadcrumb.Item>
            <Breadcrumb.Separator><Icon as={FaChevronRight} color='fg.subtle' /></Breadcrumb.Separator>
          </React.Fragment>
        ))}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  )
}
